module.exports = __webpack_public_path__ + "img/B2.09158dad.svg";